<mat-list role="list" *ngIf="clientCards$">

    <mat-list-item *ngFor="let card of clientCards$; let index = index; let last = last;" class="rad-bord clicked"
        [class.isSelected]="cardClient$ && card.id === cardClient$.id" (click)="selectCardClient(card)">

        <div matLine>

            <div class="flex flex-row items-center justify-start gap-1.5">

                <div>
                  <img src="{{card.card.logo_src}}" class="rad-bord h-10" alt="">
                </div>

                <div class="flex flex-col justify-start gap-1.5">
                    <span  class="mat-subheading-1" fxHide.xs>**** **** **** {{card.card.last4}}</span>
                    <span class="mat-subheading-1" fxHide fxShow.xs>**** {{card.card.last4}}</span>
                    <div  class="font1" *ngIf="!card.customer">{{'CardBackOfficeClientComponent.eph'|translate}} </div>
                </div>

            </div>
        </div>

        <!-- set favorite -->

        <div class="flex justify-center items-center layout-padd mt-[-5px]"
            (click)="setDefaultPaymentStripeMethod(card,$event);$event.stopPropagation();" *ngIf="clientCards$.length>1 && card.customer">
            <mat-icon fontSet="material-icons-outlined"
                *ngIf=" !defaultStripePayMethod|| defaultStripePayMethod && defaultStripePayMethod.id!=card.id">star_rate</mat-icon>
            <mat-icon *ngIf="defaultStripePayMethod && defaultStripePayMethod.id==card.id"
                style="color:rgba(245, 196, 1, 0.897);">star_rate
            </mat-icon>
        </div>

        <mat-icon mat-icon-button class="dark-ico" #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu"
            (click)="$event.stopPropagation();">more_vert</mat-icon>
        <mat-menu #menu="matMenu"  >
            <button mat-menu-item  (click)="openDialDeletCard(card, index); $event.stopPropagation();"
                angulartics2On="click" angularticsAction="openDeleteDialog"
                angularticsCategory="paymentMethods">{{"basket.delete" | translate}}</button>
        </mat-menu>

    </mat-list-item>

</mat-list>

<div *ngIf="clientCards$" fxLayout="row" fxLayoutAlign="end center"
    [ngStyle]="{'margin-top' : clientCards$.length > 0 ? '10px' : '0px'}">

    <button mat-stroked-button (click)="openDialCardSca()" angulartics2On="click" angularticsAction="openCreateDialog"
        angularticsCategory="paymentMethods">
        {{"dialogs.cards.add-card" | translate | uppercase}}
    </button>

</div>

<app-popup-loader [flagLoading]="loader" [size]="30" [statusMessage]="'CardBackOfficeClientComponent.loaderGetcard'|translate"
    [type]="'line'">
</app-popup-loader>
